import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import requests from 'app/requests/Area.requests'
import {
    LocationAreas,
} from '../LocationAreas.types'

export default (id) => {
    return useRequest<LocationAreas>({
        key: RequestKeys.getLocationArea,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(requests.get),
        enabled: Boolean(id),
        keepPreviousData: true,
    })
}
